import React, { Fragment } from 'react';

import { AnalysisRiskBoxProps } from './AnalysisRiskBox.props';
import './AnalysisRiskBox.styles.css'
import Box from "@mui/material/Box";
import { Chip, Typography } from "@mui/material";
import ErrorIcon from '@mui/icons-material/Error';
import './AnalysisRiskBox.styles.css';
import { RadialGraph } from "../../atoms/RadialGraph";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Stack from "@mui/material/Stack";
import TooltipBox from "../../atoms/TooltipBox/TooltipBox";
import {useTranslation} from "react-i18next";
import {ZONE_EXCEPTION} from "../../../constants/contants";
import { Link } from "react-router-dom";

export const AnalysisRiskBox: React.FC<AnalysisRiskBoxProps> = ({ payload = {} }) => {
  const { t } = useTranslation();

  const OverriddenIndicator = () => (
    <TooltipBox tooltip={t('tooltips.inboxDetails.statusSetByExceptionRule')}>
        <Typography fontSize={12} fontWeight={400} color="#000000e6">
            {`[ Status Overridden Via `}
            <Link to={"/settings/threat-exceptions"} className={"exception-list-navigate-link"}>Exception List</Link>
            {` ]`}
        </Typography>
    </TooltipBox>
  );

  return <Box sx={{ py: 2, px: 3 }}
              className={`analysis-risk-box analysis-risk-box-${payload?.value !== 'N/A' ? payload?.priority : 'low'}`}>
    {
      <Stack direction="row" justifyContent="space-between">
        <Stack justifyContent="space-between" position="relative" minWidth="100%">
          <Box>
            {
                payload?.value !== 'N/A' && (
                    payload?.priority === 'high' ? <>
                      <Chip icon={<ErrorIcon sx={{ ms: 0, mr: 0 }}/>} color="error" label={"Issue detected"} sx={{
                        borderRadius: "4px",
                        fontWeight: "600",
                        padding: "4px 12px",
                        marginLeft: "0px !important",
                        marginBottom: "8px",
                        color: "#fff"
                      }}/>
                    </> : payload?.priority === 'medium' || payload?.priority === 'moderate' ? <>
                      <Chip icon={<ErrorIcon sx={{ ms: 0, mr: 0 }}/>} color="warning" label="Undetermined" sx={{
                        borderRadius: "4px",
                        fontWeight: "600",
                        padding: "4px 12px",
                        marginLeft: "0px !important",
                        marginBottom: "8px",
                        color: "#fff"
                      }}/>
                    </> : (payload?.priority === 'pass' && payload?.key === 'emailAuthen') ? <>
                      <Chip icon={<CheckCircleIcon sx={{ ms: 0, mr: 0 }}/>} color="success" label="Pass"
                            className={'result-icon'} sx={{
                        borderRadius: "4px",
                        fontWeight: "600",
                        padding: "4px 12px",
                        marginLeft: "0px !important",
                        marginBottom: "8px",
                        color: "#fff",
                      }}/>
                    </> : null
                )
            }
          </Box>
          {
            Array.isArray(payload?.label) ?
                <Stack direction="row" alignItems="center" justifyContent="space-between" minWidth="100%">
                  <Stack gap={2}>
                    {
                      [payload?.label].flat().map((item, index) => <Stack>
                        <Typography variant={'body2'}
                                    className={`app-label ${payload?.key ? 'app-label-1' : null}`}
                                    sx={{
                                      marginBottom: "8px",
                                      fontWeight: payload?.key ? 600 : 400
                                    }}>{item}</Typography>
                        <Typography variant={'body2'} sx={{
                          fontWeight: payload?.key ? 400 : 600,
                          wordBreak: 'break-word',
                          whiteSpace: 'break-spaces',
                          textOverflow: 'ellipsis',
                        }}>{payload?.value[index]}</Typography>
                      </Stack>)
                    }
                    {payload?.source === ZONE_EXCEPTION && <OverriddenIndicator/>}
                  </Stack>
                  {
                    (payload?.score >= 0 && payload?.value !== 'N/A') ?
                        <Box sx={{ width: '40px', height: '40px' }} minWidth={"40px"}>
                          <RadialGraph value={payload?.score} chartLayoutPosition={{ left: 20 }} isToolTipHover={true}
                                       chartStyle={{ stroke: 'unset' }} headerRuleCategory={payload?.headerRuleCategory}
                                       authScoreAttribution={payload?.authScoreAttribution}/>
                        </Box> : <></>
                  }
                </Stack> : <Stack direction="row" justifyContent="space-between" minWidth="100%">
                  <Stack gap={2}>
                    <Stack gap={1}>
                      <Typography variant={'body2'}
                                  className={`app-label ${payload?.key ? 'app-label-1' : null}`}
                                  sx={{
                                    fontWeight: payload?.key ? 600 : 400
                                  }}>{payload?.label}</Typography>
                      {
                        payload?.content ? <Fragment>
                          {payload?.content}
                        </Fragment> : <Fragment>
                          <Typography variant={'body2'} sx={{
                            fontWeight: payload?.key ? 400 : 600,
                            wordBreak: 'break-word',
                            whiteSpace: 'break-spaces',
                            textOverflow: 'ellipsis'
                          }}>{payload?.value}</Typography>
                        </Fragment>
                      }
                    </Stack>
                    {payload?.source === ZONE_EXCEPTION && <OverriddenIndicator/>}
                  </Stack>
                  {
                    (payload?.score >= 0 && (payload?.value !== 'N/A' || payload?.key === 'emailAuthen') && !Array.isArray(payload?.label)) ?
                        <Box sx={{ width: '40px', height: '40px'}} minWidth={"40px"}>
                          <RadialGraph value={payload?.score} chartLayoutPosition={{ left: 20 }} isToolTipHover={true}
                                       chartStyle={{ stroke: 'unset' }} headerRuleCategory={payload?.headerRuleCategory}
                                       authScoreAttribution={payload?.authScoreAttribution}/>
                        </Box> : <></>
                  }
                </Stack>
          }
        </Stack>
      </Stack>
    }
  </Box>
};
